import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { isUndefined } from 'lodash';
import { FC, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import { getBgColor } from 'src/utils/icons';

const QuantityReceived: FC<GridCellProps> = (props: GridCellProps) => {
  const { dataItem, field = '', onChange, dataIndex } = props;
  const { isInProgress } = useReceiptDetails();

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: e.syntheticEvent,
        value: e.value ? Number(e.value) : undefined,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const errorMessages: string[] = useMemo(
    () => dataItem?.errors?.[field] || [],
    [dataItem?.errors, field]
  );

  const warningMessages: string[] = useMemo(
    () => dataItem?.warnings?.[field] || [],
    [dataItem?.warnings, field]
  );

  const InfosMessages: string[] = useMemo(
    () => dataItem?.informations?.[field] || [],
    [dataItem?.informations, field]
  );

  const value = dataItem[field]?.toString();
  return (
    <GridCellBase {...props} className={getBgColor(errorMessages, warningMessages, InfosMessages)}>
      {!isInProgress ? (
        <p className="text-center">{value}</p>
      ) : (
        <>
          <NumberInput
            value={isUndefined(value) ? '' : value}
            valid={!errorMessages.length && !warningMessages.length}
            onChange={handleChange}
          />
        </>
      )}
    </GridCellBase>
  );
};

export default QuantityReceived;
